import(/* webpackMode: "eager", webpackExports: ["PropertySelector"] */ "/home/runner/work/viviselect/viviselect/src/components/property-selector/property-selector.tsx");
